module.exports = __webpack_public_path__ + "12edca8efe47f9e8005f97d3fbbdd26e.png";